import { ajaxActions } from '../AjaxActions';

const BASE_URL = process.env.REACT_APP_PDF_SERVICE_URL;

export const fetchStandardLayoutContent = () =>
  ajaxActions.get(`${BASE_URL}/standardLayoutContent`).then((resp) => resp);
